import { useEffect } from "react";

import { window, document } from "@packages/global";

import {
  Accordion,
  Drawer,
  Text,
  useDrawer,
  WebmotorsSmallBrand,
} from "../../../../elements";
import { CloseIcon } from "../../../../icons";
import { useNavbar } from "../../hooks";
import { NavbarLinksMobileItem } from "./navbar-links-mobile-item.component";
import styles from "./navbar-links-mobile.module.css";

export function NavbarLinksMobile() {
  const { close, isOpen } = useDrawer();
  const {
    routes,
    user,
    onLogout,
    guestLinks,
    userLinks,
    baseURL,
    returnUrl,
    shouldOpenInSameWindow,
  } = useNavbar();

  const COCKPIT = `${routes?.COCKPIT}?lkid=1562`;

  const handleLoginClick = () => {
    if (user) {
      return;
    }

    const baseLoginUrl = `${baseURL}/login?lkid=1402`;

    const loginUrl = returnUrl
      ? returnUrl(`${baseURL}/login?lkid=1402`)
      : baseLoginUrl;

    window.open(loginUrl, "_self");
  };

  useEffect(() => {
    function resizeListener() {
      if (window.innerWidth > 842 && isOpen("mobile-drawer-menu")) {
        close("mobile-drawer-menu");
      }
    }

    window.addEventListener("resize", resizeListener);

    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, [isOpen, close]);

  useEffect(() => {
    const setViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    setViewportHeight();
    window.addEventListener('resize', setViewportHeight);
    window.addEventListener('orientationchange', setViewportHeight);
    return () => {
      window.removeEventListener('resize', setViewportHeight);
      window.removeEventListener('orientationchange', setViewportHeight);
    };
  }, []);

  function handleCloseMenu() {
    close("mobile-drawer-menu");
  }

  return (
    <Drawer name="mobile-drawer-menu" anchor="right" className={styles.Drawer}>
      <div className={styles.Header}>
        <WebmotorsSmallBrand className={styles.Logo} height={60} width={60} />
        <Text
          className={styles.Title}
          data-qa="drawer-title-button"
          title="drawer title"
          color="white"
          variant="web-subtitle-medium"
          onClick={handleLoginClick}
        >
          {!user ? "Entrar ou cadastrar" : `Olá, ${user.name}`}
        </Text>
        <button
          type="button"
          data-qa="drawer-close-button"
          className={styles.CloseButton}
          onClick={handleCloseMenu}
        >
          <CloseIcon size={40} color="white" viewBox="-2 -3 20 20" />
        </button>
      </div>
      <div className={styles.ScrollableContainer}>
        <div className={styles.Body}>
          <Text
            variant="web-subtitle-large"
            className={styles.Subtitle}
          >
            Menu
          </Text>
          <div className={styles.MenuList}>
            <Accordion isSingle>
              {user &&
                userLinks.map((section, index) => (
                  <NavbarLinksMobileItem
                    key={`${section.label}-${index}`}
                    section={section}
                  />
                ))}
              {guestLinks.map((section) => (
                <NavbarLinksMobileItem key={section.label} section={section} />
              ))}
            </Accordion>
          </div>
        </div>
        <div data-qa="drawer-footer" className={styles.Footer}>
          <Text
            as={!user ? "a" : "span"}
            href={!user ? COCKPIT : undefined}
            target={
              !user ? (shouldOpenInSameWindow ? undefined : "_blank") : undefined
            }
            rel={
              !user && !shouldOpenInSameWindow ? "noreferrer" : undefined
            }
            color="white"
            variant="body-regular-medium"
            data-qa="drawer-footer-button"
            onClick={user ? onLogout : undefined}
          >
            {!user ? (
              <>
                Acesse a plataforma do <b> Cockpit</b>
              </>
            ) : (
              "Sair"
            )}
          </Text>
        </div>
      </div>
    </Drawer>
  );
}
